module.exports = __webpack_public_path__ + "../resources/img/ico-module-setting.8967d657.svg";